// Site-visit lane keeps its own session (Cristalina OTP login), separate from
// the commissioning form's access_token, so the two lanes don't log each other out.
const TOKEN_KEY = "sv_access_token"
const REFRESH_KEY = "sv_refresh_token"
const USER_KEY = "sv_user"

export type SvUser = {
    user_id: number
    phone: number
    name: string
    email?: string
    user_initials?: string
    user_colour?: string
    role?: any
}

const svAuth = {
    token: () => localStorage.getItem(TOKEN_KEY),

    user: (): SvUser | null => {
        try {
            return JSON.parse(localStorage.getItem(USER_KEY) || "null")
        } catch {
            return null
        }
    },

    save: (tokens: { access_token: string; refresh_token?: string }, user: SvUser) => {
        localStorage.setItem(TOKEN_KEY, tokens.access_token)
        if (tokens.refresh_token) localStorage.setItem(REFRESH_KEY, tokens.refresh_token)
        localStorage.setItem(USER_KEY, JSON.stringify(user))
    },

    clear: () => {
        [TOKEN_KEY, REFRESH_KEY, USER_KEY].forEach(key => localStorage.removeItem(key))
    },
}

export default svAuth
